module.exports = __webpack_public_path__ + "fd0cace2e833f004fe537212a3d01a85.svg";